import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetBingoJackpots = () => {
    const send = useGenericSend();

    return useCallback((options: Types.IBingoJackpotsRequestData) =>
        send<Types.IBingoJackpotsRequestData>({
            ID: 81704,
            description: 'Get Bingo Jackpots',
            responses: [81705, 81706],
            version: '1.7',
            uniqueJackpots: true,
            ...options
        }), [send]);
};
